import React from 'react';

import Button from '@mui/material/Button';


export default function columnOptions(t, classes, activateCard, topUpCard, cardStatuses) {
  return {
    activateCard: {
      Cell: (tableData) => {
        const status = tableData.row.original.status;
        if (status === 'INACTIVE') {
          return (
            <Button onClick={() => activateCard(tableData.row)} className={classes.activateCardButton}>
              {t('activateCard')}
            </Button>
          );
        }

        return undefined;
      },
      muiTableBodyCellProps: {
        sx: {
          padding: 0,
        },
      },
    },
    topUpCard: {
      Cell: (tableData) => {
        return (
          <Button onClick={() => topUpCard(tableData.row)}>
            {t('topUp')}
          </Button>
        );
      },
      muiTableBodyCellProps: {
        sx: {
          padding: 0,
        },
      },
    },
    availableBalance: {
      muiTableHeadCellProps: {
        align: 'right',
      },
      muiTableBodyCellProps: {
        align: 'right',
      },
      accessorFn: handleBalance,
    },
    status: {
      Cell: (tableData) => {
        const row = tableData.row.original;
        return (
          <div>
            {cardStatuses.t(row.status)}
          </div>
        );
      },
    },
  };
};

const AMOUNT_NUMBER_OPTIONS = {
  minimumFractionDigits: 2,
};

function handleBalance(rowData) {
  const value = rowData.availableBalance;
  if (value == null) {
    return undefined;
  }
  const number = parseFloat(value);
  if (isNaN(number)) {
    console.warn('Balance is not a number? ' + value);
    return value;
  }

  return number.toLocaleString(undefined, AMOUNT_NUMBER_OPTIONS);
}
